/** @deprecated */
export const MIN_MOBILE_SCREEN = 320;

/** @deprecated */
export const MIN_TABLET_SCREEN = 768;

/** @deprecated */
export const MIN_DESKTOP_SCREEN = 1128;

/** @deprecated */
export const MIN_DESKTOP_WIDE_SCREEN = 1366;

/** @deprecated */
export enum LAYOUTS {
  MOBILE = 'mobile',
  TABLET = 'tablet',
  DESKTOP = 'desktop',
  DESKTOP_WIDE = 'desktopWide',
}

/** @deprecated */
export const BREAKPOINTS = {
  [LAYOUTS.MOBILE]: { MIN: MIN_MOBILE_SCREEN, MAX: MIN_TABLET_SCREEN - 1 },
  [LAYOUTS.TABLET]: { MIN: MIN_TABLET_SCREEN, MAX: MIN_DESKTOP_SCREEN - 1 },
  [LAYOUTS.DESKTOP]: { MIN: MIN_DESKTOP_SCREEN, MAX: MIN_DESKTOP_WIDE_SCREEN - 1 },
  [LAYOUTS.DESKTOP_WIDE]: { MIN: MIN_DESKTOP_WIDE_SCREEN },
};
